import { useTranslation } from '../../../shared/hooks/useTranslation';

export const useCalculateTime = () => {
  const { getTextIdTranslation } = useTranslation();
  const calculateTimePassed = ({ startDateStr, endDateStr }: { startDateStr: string; endDateStr?: string | Date }) => {
    const startDate = new Date(startDateStr);
    const endDate = endDateStr ? new Date(endDateStr) : new Date();

    const timeDifference = endDate - startDate;

    const millisecondsPerMinute = 60 * 1000;
    const minutes = Math.abs(Math.floor(timeDifference / millisecondsPerMinute));
    const seconds = Math.abs(Math.floor((timeDifference % millisecondsPerMinute) / 1000));

    let result = '';
    if (minutes > 1440)
      return (result += `${Math.floor(minutes / 1440)} ${
        minutes >= 1440 * 2 ? getTextIdTranslation('DAYS') : getTextIdTranslation('DAY')
      }`);
    if (minutes > 60)
      return (result += `${Math.floor(minutes / 60)} ${
        minutes >= 120 ? getTextIdTranslation('HOURS') : getTextIdTranslation('HOUR')
      }`);
    if (minutes > 0)
      return (result += `${minutes} ${minutes > 1 ? getTextIdTranslation('MINUTES') : getTextIdTranslation('MINUTE')}`);
    return (result += `${seconds} ${seconds > 1 ? getTextIdTranslation('SECONDS') : getTextIdTranslation('SECOND')}`);
  };
  return { calculateTimePassed };
};
